module.exports = __webpack_public_path__ + "static/img/cont37_05.9fcad84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_05.jpg
// module id = KZsg
// module chunks = 0